import { Badge } from '@/shared/ui/badge';
import { Button } from '@/shared/ui/button';
import { Icon } from '@/shared/ui/icon';
import { Panel, PanelGroup } from '@/shared/ui/panel';
import { AgendaPill, AgendaWindow, AgendaWindowStack } from '@/shared/ui/agenda-window';

function SampleBody() {
  return (
    <div className="gap-phx-5 flex flex-col">
      <PanelGroup columns={3} gap={12}>
        <Panel variant="outline" title="Capacity" icon="users" density="tight">
          <div className="text-phx-sm text-phx-text">
            <div className="flex items-baseline justify-between">
              <span className="text-phx-text-muted">Booked</span>
              <span className="font-semibold tabular-nums">189</span>
            </div>
            <div className="flex items-baseline justify-between">
              <span className="text-phx-text-muted">Available</span>
              <span className="font-semibold tabular-nums">56</span>
            </div>
            <div className="flex items-baseline justify-between">
              <span className="text-phx-text-muted">Waiting list</span>
              <span className="font-semibold tabular-nums">12</span>
            </div>
          </div>
        </Panel>
        <Panel variant="outline" title="Pricing" icon="trend" density="tight">
          <div className="text-phx-sm text-phx-text">
            <div className="flex items-baseline justify-between">
              <span className="text-phx-text-muted">Margin</span>
              <span className="text-phx-success font-semibold tabular-nums">18.4 %</span>
            </div>
            <div className="flex items-baseline justify-between">
              <span className="text-phx-text-muted">Avg ticket</span>
              <span className="font-semibold tabular-nums">€ 942</span>
            </div>
            <div className="flex items-baseline justify-between">
              <span className="text-phx-text-muted">Revenue</span>
              <span className="font-semibold tabular-nums">€ 178 230</span>
            </div>
          </div>
        </Panel>
        <Panel
          variant="outline"
          title="Status"
          icon="ok"
          density="tight"
          badge={<Badge tone="success">healthy</Badge>}
        >
          <p className="text-phx-sm text-phx-text-muted">
            Snapshots captured at 14:02. All connectors green.
          </p>
        </Panel>
      </PanelGroup>
    </div>
  );
}

export function WindowsSection() {
  return (
    <PanelGroup gap={12}>
      <Panel title="Standalone AgendaWindow" icon="layers" padded={false}>
        <div className="bg-phx-bg h-[520px]">
          <AgendaWindow
            breadcrumb={[
              {
                icon: <Icon name="globe" size={12} className="text-phx-info" />,
                label: 'Destinations per season',
              },
              {
                icon: <Icon name="pin" size={12} className="text-phx-warning" />,
                label: 'Mallorca · Palma & Alcudia',
                id: '#218',
              },
              { label: 'Series detail', sub: 'tour planner', current: true },
            ]}
            onClose={() => undefined}
            title="Greece — Classical Tour 2026"
            subtitle="GR-CLA-26-001 · 15.6.2026 → 21.6.2026 · 32 pax · 7 days · 6 nights"
            chips={
              <>
                <AgendaPill>
                  <strong>17</strong> activities
                </AgendaPill>
                <AgendaPill>
                  <strong>45.0</strong> programme hrs
                </AgendaPill>
                <AgendaPill tone="primary">
                  <strong>189</strong> bookings
                </AgendaPill>
              </>
            }
            actions={
              <>
                <Button size="sm">Preview</Button>
                <Button size="sm" variant="outline">
                  Discard
                </Button>
                <Button size="sm" variant="primary" iconLeft="save">
                  Save
                </Button>
              </>
            }
          >
            <SampleBody />
          </AgendaWindow>
        </div>
      </Panel>

      <Panel title="Modal stack" icon="layers" padded={false}>
        <div className="h-[520px]">
          <AgendaWindowStack>
            <AgendaWindow
              modal
              breadcrumb={[{ label: 'Destinations · Mallorca' }]}
              title="Mallorca · Palma & Alcudia"
              subtitle="Programme overview"
              onClose={() => undefined}
            >
              <SampleBody />
            </AgendaWindow>
            <AgendaWindow
              modal
              breadcrumb={[
                { label: 'Destinations', onClick: () => undefined },
                { label: 'Mallorca', onClick: () => undefined },
                { label: 'Series detail', current: true },
              ]}
              title="Series #PR-S25"
              subtitle="Per-group calculation"
              onClose={() => undefined}
            >
              <SampleBody />
            </AgendaWindow>
            <AgendaWindow
              modal
              density="tight"
              breadcrumb={[
                { label: 'Destinations', onClick: () => undefined },
                { label: 'Mallorca', onClick: () => undefined },
                { label: 'Series detail', onClick: () => undefined },
                { label: 'Edit flight', sub: 'Leg #2', current: true },
              ]}
              title="Edit transport leg"
              onClose={() => undefined}
              actions={
                <>
                  <Button size="sm">Cancel</Button>
                  <Button size="sm" variant="primary">
                    Apply
                  </Button>
                </>
              }
            >
              <SampleBody />
            </AgendaWindow>
          </AgendaWindowStack>
        </div>
      </Panel>
    </PanelGroup>
  );
}
